/**
 * Product List Tabs JavaScript
 * Handles tab switching and slideshow navigation sync
 */

class ProductListTabs {
    constructor(container) {
        this.container = container;
        this.sectionId = container.dataset.sectionId;
        this.tabs = container.querySelectorAll('.product-list-tabs__tab');
        this.collections = container.closest('.section').querySelectorAll('.product-list-collection');
        this.prevButton = container.querySelector('.product-list-tabs__arrow--prev');
        this.nextButton = container.querySelector('.product-list-tabs__arrow--next');
        this.currentIndex = 0;

        this.init();
    }

    init() {
        // Tab click handlers
        this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.switchTab(index));
        });

        // Navigation arrow handlers
        if (this.prevButton) {
            this.prevButton.addEventListener('click', () => this.navigateSlideshow('prev'));
        }
        if (this.nextButton) {
            this.nextButton.addEventListener('click', () => this.navigateSlideshow('next'));
        }
    }

    switchTab(index) {
        // Update current index
        this.currentIndex = index;

        // Update tab active states
        this.tabs.forEach((tab, i) => {
            if (i === index) {
                tab.classList.add('product-list-tabs__tab--active');
            } else {
                tab.classList.remove('product-list-tabs__tab--active');
            }
        });

        // Update collection visibility
        this.collections.forEach((collection, i) => {
            if (i === index) {
                collection.classList.add('product-list-collection--active');
            } else {
                collection.classList.remove('product-list-collection--active');
            }
        });
    }

    navigateSlideshow(direction) {
        // Find the active collection's slideshow
        const activeCollection = this.container.closest('.section').querySelector('.product-list-collection--active');
        if (!activeCollection) return;

        // Find the slideshow component within the active collection
        const slideshowComponent = activeCollection.querySelector('slideshow-component');
        if (!slideshowComponent) return;

        // Use the slideshow's navigation methods
        if (direction === 'prev') {
            // Try to call the previous slide method
            if (typeof slideshowComponent.previous === 'function') {
                slideshowComponent.previous();
            } else {
                // Fallback: click the previous button if exists
                const prevBtn = slideshowComponent.querySelector('[data-action="previous"], .slideshow-control[aria-label*="anterior"], .slideshow-control[aria-label*="previous"]');
                if (prevBtn) prevBtn.click();
            }
        } else {
            // Try to call the next slide method
            if (typeof slideshowComponent.next === 'function') {
                slideshowComponent.next();
            } else {
                // Fallback: click the next button if exists
                const nextBtn = slideshowComponent.querySelector('[data-action="next"], .slideshow-control[aria-label*="próximo"], .slideshow-control[aria-label*="next"]');
                if (nextBtn) nextBtn.click();
            }
        }
    }
}

// Initialize all product list tabs on the page
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-list-tabs').forEach(container => {
        new ProductListTabs(container);
    });
});

// Support for Shopify section reloading (editor mode)
if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
        const section = event.target;
        const tabsContainer = section.querySelector('.product-list-tabs');
        if (tabsContainer) {
            new ProductListTabs(tabsContainer);
        }
    });
}
